export default "__VITE_ASSET__e0$J15bU__"